import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const Home=()=>import('../pages/HomePage.vue')
const AllLearnView=()=>import('../pages/AllLearnPage.vue')
const NewsPage=()=>import("../pages/news/NewsPage.vue")
const LearnPage=()=>import('../pages/LearnPage.vue')
const PersonalCenterPage=()=>import("../pages/PersonalCenterPage.vue")
const RecommendView=()=>import('../pages/RecommenView.vue')
const CircleView=()=>import('../pages/CircleView.vue')
const CourseListPage=()=>import('../pages/CourseListPage.vue')
// import NewCourseView from '../pages/NewCourseView.vue'
//课程相关子页面
const HotCourseView=()=>import('../pages/course/HotCourseView.vue')
//365计划年费会员界面
const memberYear=()=>import('../pages/memberYear/memberYear.vue')
const ArticleView=()=>import('../pages/ArticleView.vue')
const VlogView=()=>import('../pages/vlog/VlogView.vue')
const VlogDetail=()=>import('../pages/vlog/VlogDetail.vue')
const VlogFullScrol=()=>import('../pages/vlog/VlogFullScrol.vue')
const SearchPage=()=>import('../pages/search/searchPage.vue')
const SearchResultPage=()=>import('../pages/search/SearchResultPage.vue')
const SearchResultSyn=()=>import('../pages/search/SearchResultSynthesize.vue')
const SearchResultCourse=()=>import('../pages/search/SearchResultCourse.vue')
const SearchResultArticle=()=>import('../pages/search/SearchResultArticle.vue')
const SearchResultUser=()=>import('../pages/search/SearchResultUser.vue')
const ArticleDetailPage=()=>import('../pages/ArticleDetailPage.vue')
const ArticleCommentPage=()=>import('../pages/ArticleCommentPage.vue')
const CourseDetailPage=()=>import('../pages/CourseDetailPage.vue')
const CourseTypeDetailPage=()=>import('../pages/CourseTypeDetailPage.vue')
const classMateListPage=()=>import('../pages/course/classMateListPage.vue')
const NewsLikePage=()=>import('../pages/news/NewsLikePage.vue')
const NewsAtPage=()=>import('../pages/news/NewsAtPage.vue')
const NewsNotifyPage=()=>import('../pages/news/NewsNotifyPage.vue')
const NewsCommentPage=()=>import('../pages/news/NewsCommentPage.vue')
const NewsOfficialReplyPage=()=>import('../pages/news/NewsOfficialReplyPage.vue')
const personalHomePage=()=>import('../pages/personalHome/personalHomePage.vue')
const LoginPage=()=>import('../pages/LoginPage.vue')
const LoginPhone=()=>import('../pages/LoginPhone.vue')
const RegisterPage=()=>import('../pages/RegisterPage.vue')
const ForgetPasswordPage=()=>import('../pages/ForgetPasswordPage.vue')
const ResetPasswordPage=()=>import('../pages/ResetPasswordPage.vue')
const HeadAndNicknamePage=()=>import('../pages/HeadAndNicknamePage.vue')
const SetUpUserInfo=()=>import('../pages/SetUpUserInfo.vue')
const SetPage=()=>import('../pages/SetPage.vue')
const CollectPage=()=>import('../pages/CollectPage.vue')
const MyCirclePage=()=>import('../pages/MyCirclePage.vue')
const FollowerPage=()=>import('../pages/FollowerPage.vue')
const RankingListPage=()=>import('../pages/RankingListPage.vue')
const bindingNo=()=>import('../pages/user/bindingNo.vue')
const loading=()=>import('../pages/user/loading.vue')
const NewSharePage=()=>import('../pages/NewSharePage.vue')
const CourseAppPay=()=>import('../pages/CourseAppPay.vue')
const GetCoupon=()=>import('../pages/coupon/GetCoupon.vue')
const AboutUsPage=()=>import('../pages/AboutUsPage.vue')
const ChangePhoneNumPage=()=>import('../pages/user/ChangePhoneNumPage.vue')
const SetNumPhoneNumPage=()=>import('../pages/user/SetNumPhoneNumPage.vue')
const FeedbackPage=()=>import('../pages/user/FeedbackPage.vue')
const MyCouponPage=()=>import('../pages/coupon/myCouponPage.vue')
const MyAccountPage=()=>import('../pages/account/MyAccountPage.vue')
const WithdrawPage=()=>import('../pages/account/WithdrawPage.vue')
const AccountListPage=()=>import('../pages/account/AccountListPage.vue')
const IncomeDetailPage=()=>import('../pages/account/IncomeDetailPage.vue')
const AccountDetailPage=()=>import('../pages/account/AccountDetailPage.vue')
const PaidHistoryPage=()=>import('../pages/account/PaidHistoryPage.vue')
const BindingAliPage=()=>import('../pages/account/BindingAliPage.vue')
const SelectZoneDescription=()=>import('../pages/user/SelectZoneDescription.vue')
const serviceTerm=()=>import('../pages/serviceTerm.vue')
const ConcernView=()=>import('../pages/circle/ConcernView.vue')
const CircleDetail=()=>import('../pages/circle/CircleDetail.vue')
const CircleComment=()=>import('../pages/circle/CircleComment.vue')
const CircleLike=()=>import('../pages/circle/CircleLike.vue')
const AddCirclePerson=()=>import('../pages/circle/AddCirclePerson.vue')
const MorePerson=()=>import('../pages/circle/MorePerson.vue')
const Fimage=()=>import('../pages/circle/Fimage.vue')
const Fvideo=()=>import('../pages/circle/Fvideo.vue')
const FocusP=()=>import('../pages/circle/FocusP.vue')
const CreatCircle=()=>import('../pages/circle/CreatCircle.vue')
const AddCircle=()=>import('../pages/circle/AddCircle.vue')
const CircleContent=()=>import('../pages/circle/CircleContent.vue')
const CircleShouldKnown=()=>import('../pages/circle/CircleShouldKnow.vue')
const ActivityView=()=>import('../pages/circle/ActivityView.vue')
const LocationView=()=>import('../pages/circle/LocationView.vue')
const ShareTrendCard=()=>import('../pages/circle/ShareTrendCard.vue')
const NoPage=()=>import('../pages/404Page.vue')
// 邀币相关界面
const myCoin=()=>import('../pages/coin/myCoin.vue')
const payCoin=()=>import('../pages/coin/payCoin.vue')
const profitCoin=()=>import('../pages/coin/profitCoin.vue')
const coinSituation=()=>import('../pages/coin/coinSituation.vue')
//打卡地
const LocationPage=()=>import('../pages/location/LocationPage.vue')
const SeleteCity=()=>import('../pages/location/SelectCity.vue')
const CityDetail=()=>import('../pages/location/CityDetail.vue')
const locationListPage=()=>import('../pages/location/locationListPage.vue')
const locatonDetail=()=>import('../pages/location/LocationDetail.vue')
const seriesDetail=()=>import('../pages/location/seriesDetail.vue')
const seriesClass=()=>import('../pages/location/seriesClass.vue')
const NewOpenApp=()=>import('../pages/location/NewOpenApp.vue')
//活动
const activityPage=()=>import('../pages/activityCon/activityPage')
const votePage=()=>import('../pages/activityCon/votePage.vue')
Vue.use(Router)
let scrollY=localStorage.getItem('scrollToY');

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
     if(to.name!='PersonalCenterPage'){
      //除了个人主页页面外的其他页面，滚动到顶部
      return {x:0,y:0}
    }
  },
  routes: 
  [{
    //404页面
      path:'/NoPage',
      name:'NoPage',
      component:NoPage,
     },
     {
      path: '/',
      component: Home,
      // redirect: '/RecommendView',
      meta:{keepAlive:false},
      children: [
        {
          path: '/',
          redirect: '/RecommendView',
          meta:{keepAlive:false}
        },
       {
          path: 'RecommendView',
          name: 'RecommendView',
          component: RecommendView,
          meta:{keepAlive:false}
        },
        {
          path: 'ConcernView',
          name: 'ConcernView',
          component: ConcernView
          // ,meta:{keepAlive:true}
        }, 
        {
          path:'ActivityView',
          name:'ActivityView',
          component:ActivityView
          // ,meta:{keepAlive:true}
        },
        {
          path:'LocationView',
          name:'LocationView',
          component:LocationView
          // ,meta:{keepAlive:true}
        }
      ]
    },
    {
      path: '/ArticleView',
      name: 'ArticleView',
      component: ArticleView
      // ,meta:{keepAlive:true}
    },
    {
      path:'/VlogView',
      name:'VlogView',
      component:VlogView
    },
    {
      path:'/VlogDetail/:vlogId',
      name:'VlogDetail',
      component:VlogDetail
    },
    {
      path:'/VlogFullScrol/:vlogId',
      name:'VlogFullScrol',
      component:VlogFullScrol
    },
    {
      path: '/AllLearnView',
      component: AllLearnView,
    },
    {
      path: '/CourseClass/:className',
      name: 'CourseClass',
      component: HotCourseView
      // ,meta:{keepAlive:true}
    },
    {
      path: '/CourseListPage/:tagNamePath',
      name: 'CourseListPage',
      component: CourseListPage
    },
    {
      path: '/CircleDetail',
      name: 'CircleDetail',
      component: CircleDetail
    },
    {
      path: '/CircleContent',
      name: 'CircleContent',
      component: CircleContent
    },
    {
      path: '/CreatCircle',
      name: 'CreatCircle',
      component: CreatCircle,
      meta:{keepAlive:true}
    },
    {
      path: '/AddCircle',
      name: 'AddCircle',
      component: AddCircle
    },
    {
      path: '/Fimage',
      name: 'Fimage',
      component: Fimage,
    },
    {
      path: '/Fvideo',
      name: 'Fvideo',
      component: Fvideo
    },
    {
      path: '/FocusP',
      name: 'FocusP',
      component: FocusP
    },
    {
      path: '/CircleComment',
      name: 'CircleComment',
      component: CircleComment
    },
    {
      path: '/CircleLike',
      name: 'CircleLike',
      component: CircleLike
    },
    {
      path: '/ShareTrendCard',
      name: 'ShareTrendCard',
      component: ShareTrendCard
    },
    {
      path: '/AddCirclePerson',
      name: 'AddCirclePerson',
      component:AddCirclePerson
    },
    {
      path: '/CircleShouldKnown',
      name: CircleShouldKnown,
      component:CircleShouldKnown
    },  
    {
      path: '/MorePerson',
      name: 'MorePerson',
      component: MorePerson
    },
    {
      path: '/RankingListPage/:RankingName',
      name: 'RankingListPage',
      component: RankingListPage
    },
    {
      path: '/NewsPage',
      name: 'NewsPage',
      component: NewsPage
    }, {
      path: '/NewsLikePage',
      name: 'NewsLikePage',
      component: NewsLikePage
    }, {
      path: '/NewsCommentPage',
      name: 'NewsCommentPage',
      component: NewsCommentPage
    },
    {
      path:'/LocationPage',
      name:'LocationPage',
      component:LocationPage,
      children:[
        {
          path:'SeleteCity',
          name:'SeleteCity',
          component:SeleteCity
        },
        {
          path:'CityDetail',
          name:'CityDetail',
          component:CityDetail
        }

      ]
    },
    {
      path:'/locationListPage/:cityId',
      name:'locationListPage',
      component:locationListPage
    },
    {
      path:'/locatonDetail/:locationId',
      name:'locatonDetail',
      component:locatonDetail
    },
    {
      path:'/seriesDetail/:seriesId',
      name:'seriesDetail',
      component:seriesDetail
    },
    {
      path:'/seriesClass/:classId',
      name:'seriesClass',
      component:seriesClass
    },
    {
      path: '/serviceTerm',
      name: 'serviceTerm',
      component: serviceTerm
    }, {
      path: '/NewsAtPage',
      name: 'NewsAtPage',
      component: NewsAtPage
    }, {
      path: '/NewsNotifyPage',
      name: 'NewsNotifyPage',
      component: NewsNotifyPage
    }, {
      path: '/NewsOfficialReplyPage',
      name: 'NewsOfficialReplyPage',
      component: NewsOfficialReplyPage
    }, {
      path: '/PersonalCenterPage',
      name: 'PersonalCenterPage',
      component: PersonalCenterPage,
      meta:{keepAlive:true}
    },
    {
      path: '/CircleView',
      name: 'CircleView',
      component: CircleView
    },
    {
      path: '/CollectPage/:userId',
      name: 'CollectPage',
      component: CollectPage,
      props:true
    }, {
      path: '/MyCirclePage/:userId',
      name: 'MyCirclePage',
      component: MyCirclePage
    }, {
      path: '/FollowerPage/:index',
      name: 'FollowerPage',
      component: FollowerPage
    },
    {
      path: '/SetUpUserInfo',
      name: 'SetUpUserInfo',
      component: SetUpUserInfo
    },
    {
      path: '/personalHomePage/:personalId',
      name: 'personalHomePage',
      component: personalHomePage
    }, 
    {
      path: '/LearnPage',
      name: 'LearnPage',
      component: LearnPage,
    },
    {
      path: '/SearchPage',
      name: 'SearchPage',
      component: SearchPage
    }, {
      path: '/SearchResultPage',
      name: 'SearchResultPage',
      component: SearchResultPage,
      // children: [{
      //   path: 'SearchResultSyn',
      //   component: SearchResultSyn
      // }, {
      //   path: 'SearchResultCourse',
      //   component: SearchResultCourse
      // }, {
      //   path: 'SearchResultArticle',
      //   component: SearchResultArticle
      // }, {
      //   path: 'SearchResultUser',
      //   component: SearchResultUser
      // }]
    }, {
      path: '/ArticleDetailPage/:articleId',
      name: 'ArticleDetailPage',
      component: ArticleDetailPage
    },
    {
      path: '/ArticleCommentPage/:articleId',
      name: 'ArticleCommentPage',
      component: ArticleCommentPage
    }, 
    {
      path: '/CourseDetailPage/:courseId',
      name: 'CourseDetailPage',
      component: CourseDetailPage
    }, 
    {
      path: '/CourseTypeDetailPage/:courseTypeId',
      name: 'CourseTypeDetailPage',
      component: CourseTypeDetailPage
    },
    {
      path: '/LoginPage/:fromPath',
      name: 'LoginPage',
      component: LoginPage
    },
    
    {
      path: '/LoginPhone/:fromPath',
      name: 'LoginPhone',
      component: LoginPhone
    },
    {
      path: '/RegisterPage/:fromPath',
      name: 'RegisterPage',
      component: RegisterPage
    }, {
      path: '/ForgetPasswordPage/:fromPath',
      name: 'ForgetPasswordPage',
      component: ForgetPasswordPage
    },
    {
      path: '/ResetPasswordPage/:fromPath',
      name: 'ResetPasswordPage',
      component: ResetPasswordPage
    },
    {
      path: '/HeadAndNicknamePage/:fromPath',
      name: 'HeadAndNicknamePage',
      component: HeadAndNicknamePage
    },
    {
      path: '/user/SetPage',
      name: 'SetPage',
      component: SetPage
    }, {
      path: '/user/bindingNo/:fromPath',
      name: 'bindingNo',
      component: bindingNo
    }, {
      path: '/user/loading',
      name: 'loading',
      component: loading
    }, {
      path: '/NewSharePage/:courseId',
      name: 'NewSharePage',
      component: NewSharePage
    }, {
      path: '/CourseAppPay/:courseId',
      name: 'CourseAppPay',
      component: CourseAppPay
    },
    {
      path: '/user/coupon',
      name: 'getCoupon',
      component: GetCoupon
    },
    {
      path: '/user/MyCouponPage',
      name: 'MyCouponPage',
      component: MyCouponPage
    },
    {
      path: '/user/MyAccountPage',
      name: 'MyAccountPage',
      component: MyAccountPage
    },
    {
      path: '/user/AboutUsPage',
      name: 'AboutUsPage',
      component: AboutUsPage
    },
    {
      path: '/user/ChangePhoneNumPage',
      name: 'ChangePhoneNumPage',
      component: ChangePhoneNumPage
    },
    {
      path: '/user/SetNumPhoneNumPage',
      name: 'SetNumPhoneNumPage',
      component: SetNumPhoneNumPage
    },
    {
      path: '/user/FeedbackPage',
      name: 'FeedbackPage',
      component: FeedbackPage
    },
    {
      path: '/user/WithdrawPage',
      name: 'WithdrawPage',
      component: WithdrawPage
    },
    {
      path: '/user/AccountListPage',
      name: 'AccountListPage',
      component: AccountListPage
    },
    {
      path: '/user/IncomeDetailPage',
      name: 'IncomeDetailPage',
      component: IncomeDetailPage
    },
    {
      path: '/user/AccountDetailPage',
      name: 'AccountDetailPage',
      component: AccountDetailPage
    },
    {
      path: '/user/PaidHistoryPage',
      name: 'PaidHistoryPage',
      component: PaidHistoryPage
    },
    {
      path: '/user/BindingAliPage',
      name: 'BindingAliPage',
      component: BindingAliPage
    },
    {
      path: '/user/SelectZoneDescription',
      name: 'SelectZoneDescription',
      component: SelectZoneDescription
    },
    {
      // path: '/myCoin/:index',
      path: '/myCoin',
      name: 'myCoin',
      component: myCoin
    }
    ,{
      path: '/payCoin',
      name: 'payCoin',
      component: payCoin
    }
    ,{
      path: '/profitCoin',
      name: 'profitCoin',
      component: profitCoin
    }
    ,{
      path: '/coinSituation',
      name: 'coinSituation',
      component: coinSituation
    }
    ,{
      path: '/memberYear',
      name: 'memberYear',
      component: memberYear
    },
    {
      path:'/NewOpenApp',
      name:'NewOpenApp',
      component:NewOpenApp
    },
    {
      path:'/activityPage/:userId',
      name:'activityPage',
      component:activityPage
    },
    {
     path:'/votePage/:trendId',
     name:'votePage',
     component:votePage
    },
    {
      path:'/classMateListPage/:classId',
      name:'classMateListPage',
      component:classMateListPage
    },
  ],
})




// WEBPACK FOOTER //
// ./src/router/index.js